import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from './stores/auth'

const routes: RouteRecordRaw[] = [
  // Viewer (anonymous)
  { path: '/', component: () => import('./views/viewer/Browse.vue') },
  { path: '/read/:comicId', component: () => import('./views/viewer/Reader.vue'), props: true },

  // Admin
  { path: '/admin/login', component: () => import('./views/admin/Login.vue') },
  {
    path: '/admin',
    component: () => import('./views/admin/Home.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/comics',
    component: () => import('./views/admin/Comics.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/comics/:id',
    component: () => import('./views/admin/ComicDetail.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/admin/comics/:comicId/chapters/:chapterId',
    component: () => import('./views/admin/ChapterDetail.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/admin/comics/:comicId/chapters/:chapterId/import',
    component: () => import('./views/admin/ImportPage.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/admin/characters',
    component: () => import('./views/admin/Characters.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/users',
    component: () => import('./views/admin/Users.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/admin/users/:id',
    component: () => import('./views/admin/UserDetail.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/admin/audit',
    component: () => import('./views/admin/Audit.vue'),
    meta: { requiresAuth: true },
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Auth guard: any route with meta.requiresAuth bounces to /admin/login when no token.
router.beforeEach((to) => {
  if (!to.meta.requiresAuth) return true
  const auth = useAuthStore()
  if (auth.isLoggedIn) return true
  return { path: '/admin/login', query: { next: to.fullPath } }
})
